import { Button, Card, Stack, Text } from 'braid-design-system';

import { useShoppingCart } from 'src/app/shared/hooks/useShoppingCart';
import { usePaywall } from 'src/app/v1/views/hooks/usePaywall';

const STANDOUT_AD = 'caaf594b-bae5-4593-a546-3a8efdc87421';

/**
 * Delete this component when monetisation has released their wuidget
 * This is only temporary hence hardcdoded product ids
 * @returns
 */
export const PlaceholderUpgradeSection = () => {
  const { addLineItem } = useShoppingCart();
  const { isPaywallVisible, greyedOutFeatures } = usePaywall();

  if (!isPaywallVisible) {
    return null;
  }

  return (
    <PlaceholderUpgradeWidget
      onClick={() => {
        addLineItem({
          productId: STANDOUT_AD,
          productType: 'AdProduct',
        });
      }}
      featureNames={greyedOutFeatures.map((feature) => feature?.name)}
    />
  );
};

interface PlaceholderUpgradeWidgetProps {
  onClick: () => void;
  featureNames?: (string | undefined)[];
}

export const PlaceholderUpgradeWidget = (
  props: PlaceholderUpgradeWidgetProps,
) => (
  <Card>
    <Stack space="medium">
      <Text>
        Upgrade to get these features: {props.featureNames?.join(', ')}
      </Text>
      <Button onClick={props.onClick}>Upgrade</Button>
    </Stack>
  </Card>
);
